<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Présences aux ateliers">
        <v-row v-if="ateliers.length > 0">
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="ateliers"
              :items-per-page="10"
              item-key="id"
              class="elevation-1"
            >
              <template v-slot:item.campus="{ item }">
                {{ item.campus.libelle }}
              </template>
              <template v-slot:item.ouvert="{ item }">
                <span v-if="isAtelierEchu(item)">Échu</span>
                <span v-else-if="!item.ouvert">Fermé</span>
                <span v-else-if="item.nbInscrits >= item.nbPlaces">Plein</span>
                <span v-else>Ouvert</span>
              </template>
              <template v-slot:item.action="{ item }">
                <router-link
                  v-if="item.nbInscrits > 0"
                  :to="{
                    name: 'emargement-atelier',
                    params: {
                      idAtelier: item.id
                    }
                  }"
                >
                  <v-icon
                    v-if="isAtelierEchu(item)"
                    class="mr-2"
                    title="Émargement"
                    color="primary"
                    >mdi-playlist-check</v-icon
                  >
                  <v-icon
                    v-else
                    class="mr-2"
                    title="Voir les inscrits"
                    color="primary"
                    >mdi-format-list-bulleted</v-icon
                  ></router-link
                >
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-subheader>Actuellement vous n'animez aucun atelier</v-subheader>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiAtelierRepository from "@/repositories/ApiAtelierRepository";
import moment from "moment";

export default {
  name: "ListeAteliersAnimateur",
  components: { BaseBlock },

  data() {
    return {
      headers: [
        {
          text: "Campus",
          align: "left",
          value: "campus"
        },
        {
          text: "Date et heure début",
          align: "left",
          value: "dateDebut"
        },
        {
          text: "Lieu",
          align: "left",
          value: "lieu"
        },
        {
          text: "État",
          align: "left",
          value: "ouvert",
          sortable: false
        },
        {
          text: "Nombre d'inscrits",
          align: "left",
          value: "nbInscrits"
        },
        {
          text: "Nombre de présents",
          align: "left",
          value: "nbPresents"
        },
        {
          text: "Action",
          align: "center",
          value: "action"
        }
      ],
      ateliers: []
    };
  },
  async created() {
    await this.getAteliers();
  },
  methods: {
    async getAteliers() {
      try {
        const ateliers = await ApiAtelierRepository.getAteliersByAnimateur();
        this.ateliers = ateliers;
      } catch (error) {
        if (error.response) {
          if (error.response.data.status !== 404) {
            this.$toast.error(error.response.data.messages[0]);
          }
        }
      }
    },
    formatDateDebut(dateDebut) {
      return moment(dateDebut).format("DD/MM/YYYY HH:mm");
    },
    isAtelierEchu(atelier) {
      return moment() > moment(atelier.dateDebut) ? true : false;
    }
  }
};
</script>
